import { inject, Signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { GlobalService } from '../services/global.service';
import { SecureStorageService } from '../services/secure-storage.service';
import { CommonDataStore } from '../state-management/global.store';
import { API_KEYS } from '../state-management/api.config';

export const superAdminGuard: CanActivateFn = () => {
    const router = inject(Router);
    const globalService = inject(GlobalService);
    const store = inject(CommonDataStore);
    const secureStorage = inject(SecureStorageService);

    const permissionSlice = (store as any)[API_KEYS.PERMISSION] as Signal<any>;
    const slice = permissionSlice();
    if (!slice.loaded && !slice.loading) {
        const storedId = secureStorage.getStorage('id');
        const id = storedId ? Number(storedId) : null;
        if (id) store.reloadapi(API_KEYS.PERMISSION, { id });
    }

    return toObservable(permissionSlice).pipe(

        filter((state: any) => state.loaded || !!state.error),
        take(1),
        map(() => globalService.isSuperAdmin() ? true : router.createUrlTree(['/home'])),
    );
};
